import { render, staticRenderFns } from "./uniqueFeature.vue?vue&type=template&id=1ab1553d&scoped=true&"
import script from "./uniqueFeature.vue?vue&type=script&lang=js&"
export * from "./uniqueFeature.vue?vue&type=script&lang=js&"
import style0 from "./uniqueFeature.vue?vue&type=style&index=0&id=1ab1553d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab1553d",
  null
  
)

export default component.exports